import isEqual from 'lodash/isEqual'
import uniqWith from 'lodash/uniqWith'
export function intersection<T>(a: T[], b: T[]): T[] {
  return a.filter((x) => b.includes(x))
}

/**
 * Returns a new array containing only the unique values from the input array.
 * Uniqueness is determined by deep equality.
 *
 * @param arr - The array of values to be filtered.
 * @returns A new array with duplicates removed.
 */
export function uniq<T>(arr: T[]): T[] {
  return uniqWith(arr, isEqual)
}

export function take<T>(a: T[], n: number): T[] {
  return a.slice(0, n)
}

export function flatten<T>(a: T[][]): T[] {
  return a.flat()
}

export function addUniq<T>(arr: T[], values: T[]): T[] {
  return uniq([...arr, ...values])
}

export function removeUniq<T>(arr: T[], values: T[]): T[] {
  return arr.filter((item) => !values.some((v) => isEqual(item, v)))
}

export function isAnyOf<T>(value: T, values: T[]): boolean {
  return values.some((v) => isEqual(value, v))
}
